import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UserData } from '@chefami-monorepo/types';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  // Input signal for footer options
  readonly options = input.required<UserData>();
}
